import { render, staticRenderFns } from "./archiveEmployees.vue?vue&type=template&id=ce637a0e&scoped=true"
import script from "./archiveEmployees.vue?vue&type=script&lang=js"
export * from "./archiveEmployees.vue?vue&type=script&lang=js"
import style0 from "./archiveEmployees.vue?vue&type=style&index=0&id=ce637a0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce637a0e",
  null
  
)

export default component.exports